/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
  const mainTex = scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS);
  fixPivot(mainTex, 'bat_animation/', BatAnimationData.frames);

  for (const key in BatAnimationData.animations) {
    addAnimation(scene.anims, key, BatAnimationData, 'bat_animation');
  }
}

/**
 * 
 * @param {Phaser.Animations.AnimationManager} animationManager 
 * @param {string} key 
 */
function addAnimation(animationManager, key, data, prefix) {
  if (animationManager.exists(key)) return;

  const frames = [];
  const animationData = data.animations[key];
  animationData.frames.forEach(frameNum => frames.push({ frame: `${prefix}/${frameNum.toString()}` }));
  animationManager.create(
    {
      defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frameRate: (animationData.framerate ?? 24) * (animationData.speed ?? 1),
      key,
      frames,
      repeat: key === animationData.next ? -1 : 0
    }
  );
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
  frameData.forEach((data, index) => {
    const frame = texture.get(prefix + index);
    frame.customPivot = true;
    frame.pivotX = data[5] / data[2];
    frame.pivotY = data[6] / data[3];
  });
}

// this data comes from the original game; this is the CreateJs sprite sheet animation export

const BatAnimationData = {
  frames: [
    [944, 172, 314, 149, 0, -10, -28],
    [1486, 2, 303, 158, 0, -11, -18],
    [2, 2, 286, 166, 0, -13, -9],
    [582, 2, 297, 161, 0, -10, -13],
    [2, 172, 308, 155, 0, -6, -18],
    [626, 172, 314, 150, 0, -4, -22],
    [314, 172, 308, 154, 0, -6, -18],
    [1184, 2, 298, 160, 0, -9, -13],
    [292, 2, 286, 165, 0, -13, -9],
    [883, 2, 297, 160, 0, -12, -15]
  ],
  animations: {
    Bat_loop: {
      frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      speed: 0.5,
      next: 'Bat_loop'
    }
  }
};